module.exports = __webpack_public_path__ + "img/scb.aa1db6b1.svg";